/**
 * Generates a lookup (read) operation script for CRUD tools
 */

/**
 * Generates a lookup operation script
 */
export function generateLookupScript(): string {
    return String.raw`(function (inputs) {


    // parses query expression containing {{variables}}
    // by replacing {{variableName}} with the value of the variableName property in the inputs object
    // if the variableName property is not found in the inputs object, the variableName is returned as is
    function parseQuery(expression, inputs) {
        if (!expression) return '';
        return expression.replace(
            /{{\s*(\w+)\s*}}/g,
            function (match, variableName) {
                if (inputs && inputs.hasOwnProperty(variableName)) {
                    return inputs[variableName];
                }
                return '';
            }
        );
    }


    var table = inputs.crudInputs.table.value;
    var tableName = inputs.crudInputs.table.displayValue;
    var query = parseQuery(inputs.crudInputs.query, inputs);
    var sortType = inputs.crudInputs.sortType;
    var orderBy = inputs.crudInputs.orderBy;
    var limit = inputs.crudInputs.limit || 5;
    var fields = inputs.crudInputs.returnFields || [];


    var results = [];
    var protectedRecords = 0;
    var gr = new GlideRecordSecure(table);
    if (query) {
        gr.addEncodedQuery(query, true);
    } else {
        gs.error('[AIA error] No query provided');
        return {
            message: 'No query provided',
            status: sn_i18n.Message.getMessage('sn_aia', 'error'),
        };
    }


    if (orderBy && sortType === 'a_to_z') {
        gr.orderBy(orderBy);
    } else if (orderBy && sortType !== 'a_to_z') {
        gr.orderByDesc(orderBy);
    }


    gr.setLimit(limit);
    gr.query();
    while (gr.next()) {
        var fieldObj = {};
        if (gr.canRead()) {
            fields.forEach(function (field) {
                if (gr.canRead(field.id)) {
                    // store both value and display value for consistency with other field types
                    fieldObj[field.id] = {
                        value: gr.getValue(field.id),
                        displayValue: gr.getDisplayValue(field.id),
                    };
                }
            });
        } else {
            protectedRecords++;
        }
        results.push(fieldObj);
    }


    var recordCount = results.length;
    var total = recordCount + protectedRecords;
    var message = sn_i18n.Message.getMessage(
        'sn_aia',
        '{count} out of {total} records returned from the {table} table.',
        {
            count: recordCount.toString(),
            total: total.toString(),
            table: tableName,
        }
    );


    return {
        records: results,
        message: message,
        status: sn_i18n.Message.getMessage('sn_aia', 'success'),
    };
})(inputs);`
}
